import Api from '../../../services/Api';
import type { BusinessRuleFact, BusinessRulesTargets, EntityType } from '../types/business-rules-schemas';

interface BusinessRulesRequest {
  entityType: EntityType;
  entityKey: string;
  facts: BusinessRuleFact;
}

interface BusinessRulesResponse {
  targets: BusinessRulesTargets;
  hasMerging: boolean;
}

class BusinessRulesService extends Api {
  async evaluateBusinessRules({
    entityType = 'product',
    entityKey,
    facts,
  }: BusinessRulesRequest): Promise<BusinessRulesResponse> {
    const queryParams = new URLSearchParams();
    queryParams.append('facts', JSON.stringify(facts));

    const { data } = await this.httpClient.get<BusinessRulesResponse>(
      `/v2/rules/${entityType}/${encodeURIComponent(entityKey)}/evaluate?${queryParams.toString()}`,
    );

    return data;
  }
}

export default BusinessRulesService;
